import { render, staticRenderFns } from "./StorefrontNotFoundMessage.vue?vue&type=template&id=6797761a&"
import script from "./StorefrontNotFoundMessage.vue?vue&type=script&lang=js&"
export * from "./StorefrontNotFoundMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports